// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"w4-z","displaySixCardTiles":"x4-z"};